import { render, staticRenderFns } from "./Localities.vue?vue&type=template&id=1678bc39&scoped=true"
import script from "./Localities.vue?vue&type=script&lang=js"
export * from "./Localities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1678bc39",
  null
  
)

export default component.exports